var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "courseScheduleDetailModal",
      staticClass: "modal fade course-schedules-details",
      attrs: { tabindex: "-1", "aria-hidden": "true" },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-xl" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _vm.courseSchedule
              ? _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(
                    "\n                    #" +
                      _vm._s(_vm.courseSchedule.id) +
                      " " +
                      _vm._s(_vm.courseSchedule.course.name) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.hide()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.viewType === "show"
            ? _c("div", [
                _vm.courseSchedule
                  ? _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("h5", [
                            _vm._v(
                              "Course Schedule #" +
                                _vm._s(_vm.courseSchedule.id)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Path"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.courseSchedule.path.name) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Status"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm.courseSchedule.is_active
                                ? _c("span", { staticClass: "text-success" }, [
                                    _vm._v("active"),
                                  ])
                                : _c("span", { staticClass: "text-danger" }, [
                                    _vm._v("not active"),
                                  ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Date")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.dateFormat(
                                      _vm.courseSchedule.from,
                                      "dddd, D MMM"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Time")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm._v(
                                "\n                                    from " +
                                  _vm._s(
                                    _vm.dateFormat(
                                      _vm.courseSchedule.from,
                                      "h:mm a"
                                    )
                                  ) +
                                  " till\n                                    " +
                                  _vm._s(
                                    _vm.dateFormat(
                                      _vm.courseSchedule.till,
                                      "h:mm a"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Class")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: _vm.courseSchedule.course.link,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.courseSchedule.course.name))]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Trainer")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm.courseSchedule.trainer
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href: _vm.courseSchedule.trainer.link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.courseSchedule.trainer.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("span", [_vm._v("no")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Level"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.courseSchedule.level.name) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Capacity"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.courseSchedule.capacity) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Location")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _vm.courseSchedule.location
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href: _vm.courseSchedule.location
                                            .link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.courseSchedule.location.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.courseSchedule.location_comment
                                ? _c("span", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.courseSchedule.location_comment
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("h5", [_vm._v("Guests")]),
                          _vm._v(" "),
                          _vm.courseOrders.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "table-responsive course-orders",
                                  staticStyle: {
                                    "max-height": "400px",
                                    "overflow-y": "auto",
                                  },
                                },
                                [
                                  _c(
                                    "table",
                                    { staticClass: "table table-reset" },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.courseOrders,
                                          function (order) {
                                            return _c(
                                              "tr",
                                              { staticClass: "course-order" },
                                              [
                                                _c("td", [
                                                  order.booking
                                                    ? _c("span", [
                                                        order.booking.link
                                                          ? _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: order
                                                                    .booking
                                                                    .link,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    order
                                                                      .booking
                                                                      .name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  order.booking
                                                                    .name
                                                                )
                                                              ),
                                                            ]),
                                                      ])
                                                    : _vm._e(),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(order.path)),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getRoomParamForGuest(
                                                        order.user.id,
                                                        "number"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: _vm.getGuestParam(
                                                          order.user.id,
                                                          "link"
                                                        ),
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(order.user.name)
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  order.link
                                                    ? _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: order.link,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "90%",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "open_in_new"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _c("div", [_c("em", [_vm._v("no orders yet")])]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "app-required" }),
                      _vm._v(
                        " This field will be displayed in the RESET Guest App.\n\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.courseSchedule
                    ? _c("div", { staticStyle: { "margin-right": "auto" } }, [
                        _vm.courseSchedule.url
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-info",
                                attrs: {
                                  href: _vm.courseSchedule.url,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Open in new tab")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.refresh()
                              },
                            },
                          },
                          [_vm._v("Refresh")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.hide()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _vm.allow.edit
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.toEdit()
                            },
                          },
                        },
                        [_vm._v("Edit")]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.viewType === "edit" && _vm.allow.edit
            ? _c("div", [
                _vm.courseScheduleForm
                  ? _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("h5", [
                            _vm._v(
                              "Edit Course Schedule #" +
                                _vm._s(_vm.courseScheduleForm.id)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Status"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.courseScheduleForm.is_active,
                                      expression:
                                        "courseScheduleForm.is_active",
                                    },
                                  ],
                                  staticClass: "form-select",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.courseScheduleForm,
                                        "is_active",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("not active"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("active"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Date")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.courseScheduleForm.date,
                                    expression: "courseScheduleForm.date",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "date" },
                                domProps: {
                                  value: _vm.courseScheduleForm.date,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.courseScheduleForm,
                                      "date",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Time")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-1 label" }, [
                              _vm._v("From"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.courseScheduleForm.time_from,
                                    expression: "courseScheduleForm.time_from",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "time" },
                                domProps: {
                                  value: _vm.courseScheduleForm.time_from,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.courseScheduleForm,
                                      "time_from",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-1 label" }, [
                              _vm._v("Till"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.courseScheduleForm.time_till,
                                    expression: "courseScheduleForm.time_till",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "time" },
                                domProps: {
                                  value: _vm.courseScheduleForm.time_till,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.courseScheduleForm,
                                      "time_till",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Class")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.courseScheduleForm.course_id,
                                      expression:
                                        "courseScheduleForm.course_id",
                                    },
                                  ],
                                  staticClass: "form-select",
                                  attrs: { title: "courses" },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.courseScheduleForm,
                                          "course_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function ($event) {
                                        return _vm.updateTrainer()
                                      },
                                    ],
                                  },
                                },
                                _vm._l(_vm.library.courses, function (course) {
                                  return _c(
                                    "option",
                                    { domProps: { value: course.id } },
                                    [_vm._v(_vm._s(course.name))]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Trainer")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.courseScheduleForm.trainer_id,
                                      expression:
                                        "courseScheduleForm.trainer_id",
                                    },
                                  ],
                                  staticClass: "form-select",
                                  attrs: { title: "trainers" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.courseScheduleForm,
                                        "trainer_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.library.trainers,
                                  function (trainer) {
                                    return _c(
                                      "option",
                                      { domProps: { value: trainer.id } },
                                      [_vm._v(_vm._s(trainer.name))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Level"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.courseScheduleForm.course_level_id,
                                      expression:
                                        "courseScheduleForm.course_level_id",
                                    },
                                  ],
                                  staticClass: "form-select",
                                  attrs: { title: "levels" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.courseScheduleForm,
                                        "course_level_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.library.levels, function (level) {
                                  return _c(
                                    "option",
                                    { domProps: { value: level.id } },
                                    [_vm._v(_vm._s(level.name))]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Capacity"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.courseScheduleForm.capacity,
                                    expression: "courseScheduleForm.capacity",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number" },
                                domProps: {
                                  value: _vm.courseScheduleForm.capacity,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.courseScheduleForm,
                                      "capacity",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 label app-required" },
                              [_vm._v("Location")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.courseScheduleForm.location_id,
                                      expression:
                                        "courseScheduleForm.location_id",
                                    },
                                  ],
                                  staticClass: "form-select",
                                  attrs: { title: "locations" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.courseScheduleForm,
                                        "location_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.library.locations,
                                  function (location) {
                                    return _c(
                                      "option",
                                      { domProps: { value: location.id } },
                                      [_vm._v(_vm._s(location.name))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col-md-4 label" }, [
                              _vm._v("Location comment"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.courseScheduleForm.location_comment,
                                    expression:
                                      "courseScheduleForm.location_comment",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", maxlength: "150" },
                                domProps: {
                                  value:
                                    _vm.courseScheduleForm.location_comment,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.courseScheduleForm,
                                      "location_comment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.courseSchedule
                          ? _c("div", { staticClass: "col-md-6" }, [
                              _c("h5", [_vm._v("Guests In Session")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Max " + _vm._s(_vm.availability) + " allowed"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "table-responsive course-orders",
                                  staticStyle: {
                                    "max-height": "400px",
                                    "overflow-y": "auto",
                                  },
                                },
                                [
                                  _c(
                                    "table",
                                    { staticClass: "table table-reset" },
                                    [
                                      _vm._m(1),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        [
                                          _vm._l(
                                            _vm.courseOrders,
                                            function (order) {
                                              return _c(
                                                "tr",
                                                { staticClass: "course-order" },
                                                [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(order.booking.name)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(_vm._s(order.path)),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getRoomParamForGuest(
                                                          order.user.id,
                                                          "number"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(order.user.name)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-sm btn-danger",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.cancelCourseOrder(
                                                              order
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("cancel")]
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.getGuestsAllowedToAdd(),
                                            function (bookingUser) {
                                              return _c(
                                                "tr",
                                                { staticClass: "course-order" },
                                                [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        bookingUser.booking.name
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(bookingUser.path)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    bookingUser.room
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              bookingUser.room
                                                                .number
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        bookingUser.user.name
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm.isGuestAvailable(
                                                      bookingUser.user
                                                    )
                                                      ? _c("span", [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-sm btn-success",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.order(
                                                                      bookingUser
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("add")]
                                                          ),
                                                        ])
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-muted",
                                                          },
                                                          [_vm._v("busy")]
                                                        ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "app-required" }),
                      _vm._v(
                        " This field will be displayed in the RESET Guest App.\n\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toShow()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", disabled: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v("Save changes")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("booking")]),
        _vm._v(" "),
        _c("th", [_vm._v("path")]),
        _vm._v(" "),
        _c("th", [_vm._v("room")]),
        _vm._v(" "),
        _c("th", [_vm._v("name")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("booking")]),
        _vm._v(" "),
        _c("th", [_vm._v("path")]),
        _vm._v(" "),
        _c("th", [_vm._v("room")]),
        _vm._v(" "),
        _c("th", [_vm._v("name")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }